import React from 'react';
import styled from '@emotion/styled';

import Logos from './Logos';
import Introduction from './Introduction';
import CTA from './CTA';
import Hero from './Hero';
import MauerBack from './MauerBack';
import Stacheldraht from '../Stacheldraht';
import PageLayout from '../PageLayout';

import { mediaPhone, mediaTablet, minDesktop } from '../styles/breakpoints';

const Header = styled.header`
  position: relative;
  ${minDesktop} {
    top: 0;
    left: 25px;
  }

  padding-top: 25px;
  ${mediaPhone} {
    padding-top: 5px;
  }
`;

const MauerContent = styled.div`
  display: flex;
  justify-content: space-between;

  padding-top: 70px;

  ${mediaTablet} {
    padding-top: 0;
    padding-left: 16px;
  }

  ${mediaPhone} {
    padding-left: 0;
    display: block;
  }
`;

const StacheldrahtStyled = styled(Stacheldraht)`
  position: absolute;
  top: -40px;

  ${mediaPhone} {
    width: 100vw;
    left: 0px;
    top: -62px;
  }
`;

const IntroductionStyled = styled(Introduction)`
  position: relative;
  z-index: 30;
  flex-basis: 49.5%;
  order: 20;
  padding: 0 60px 0 20px;

  ${mediaTablet} {
    padding: 0 40px 0 0;
  }

  ${mediaPhone} {
    padding: 0;
  }
`;

const centerVertical = `
  margin-left: auto;
  margin-right: auto;
`;

const HeroStyled = styled(Hero)`
  z-index: 20;
  flex-basis: 49%;
  order: 10;

  ${mediaPhone} {
    ${centerVertical}
    order: 20;
    position: relative;
    top: -80px;
    margin-bottom: -80px;
    max-width: 90vw;
  }

  @media (max-width: 576px) { top: -100px; margin-bottom: -100px; }
  @media (max-width: 475px) { top: -120px; margin-bottom: -120px; }
`;

const CTAStyled = styled(CTA)`
  position: absolute;
  z-index: 10;

  top: -130px;
  left: 50px;

  ${mediaTablet} {
    top: -108px;
    left: 25px;
  }

  ${mediaPhone} {
    ${centerVertical}
    position: relative;
    top: auto;
    left: auto;
    order: 10;
  }
`;

const PageHeader = () => (
  <Header>
    <PageLayout>
      <Logos />
      <MauerBack>
        <StacheldrahtStyled />
        <MauerContent>
          <IntroductionStyled />
          <CTAStyled />
          <HeroStyled />
        </MauerContent>
      </MauerBack>
    </PageLayout>
  </Header>
);

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader/PageHeader.js